export type TerminalRouteMode = "product" | "website" | "login"

const normalizedPathname = (pathname: string) =>
  pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname

export function resolveTerminalRouteMode({
  pathname,
  isAuthorized,
}: {
  pathname: string
  isAuthorized: boolean
}): TerminalRouteMode {
  if (isAuthorized) return "product"
  if (normalizedPathname(pathname) === "/terminal") return "website"
  return "login"
}
